export const SORT_TYPES: { string: "string"; number: "number" } = {
  string: "string",
  number: "number",
};
